"use client";

import { Button } from "@/components/buttons/Button";
import { Modal } from "@/components/Modal";
import { NormalText } from "@/components/text/NormalText";

// Any plan change resets the balance to the new plan's allocation (see handleInvoicePaid), so a yearly subscriber forfeits banked time; downgrades already warn.
export function SwitchToMonthlyModal({
  open,
  closeModal,
  onConfirm,
  isLoading,
}: {
  open: boolean;
  closeModal: () => void;
  onConfirm: () => Promise<void>;
  isLoading: boolean;
}) {
  return (
    <Modal
      open={open}
      closeModal={closeModal}
      title="Switch to monthly billing"
      widthMode="normal"
    >
      <NormalText elementType="p" className="mb-4">
        Switching to monthly resets your conversion time to the monthly
        allowance. Any unused time you have built up on your yearly plan will
        not carry over.
      </NormalText>
      <NormalText elementType="p" className="mb-6">
        Do you want to switch to monthly billing?
      </NormalText>
      <div className="flex w-full justify-between gap-x-4">
        <Button onClick={closeModal} className="w-full">
          Keep yearly
        </Button>
        <Button
          variant="error"
          onClick={onConfirm}
          loading={isLoading}
          className="w-full"
        >
          Switch to monthly
        </Button>
      </div>
    </Modal>
  );
}
